<template>
  <v-dialog v-model="dialog" max-width="500" scrollable>
    <template v-slot:activator="{ on }">
      <div class="primary--text triggerText" v-on="on">
        Other company listings
      </div>
    </template>
    <v-card>
      <v-card-title>{{ currentMed }}</v-card-title>
      <v-card-subtitle class="my-1 subtitle-2">
        These medications may be similar to {{ currentMed }}. Click a medication
        to go to that listing.</v-card-subtitle
      >
      <v-divider></v-divider>
      <v-card-text class="px-0 px-sm-4">
        <div v-for="(row, index) in similarMeds" :key="index">
          <!-- {{ row.brand_name }} -->
          <v-hover v-slot="{ hover }">
            <v-card
              flat
              :class="{ bHoverin: hover }"
              class="my-2 pointer"
              @click="detailsRouter(row.id, row.brand_name)"
            >
              <v-card-text class="d-flex flex-row">
                <div class="imageDivWidth">
                  <med-package-image
                    :imageFile="row.file"
                    :defaultHeight="80"
                    :productForm="row.product_form"
                    :maxWidth="60"
                    class=""
                  ></med-package-image>
                </div>
                <div>
                  <div class="font-weight-bold">{{ row.labeler_name }}</div>
                  {{ row.brand_name }}<br />
                  <!-- {{ row.synonym }} -->
                  <med-icon-block
                    :listing="row"
                    class=""
                    :row="true"
                  ></med-icon-block>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </div>

        <!-- <v-data-table
    :headers="headers"
    :items="similarMeds"
    class="elevation-1"
    
  ></v-data-table> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Slugify from "slugify";
import MedIconBlock from "./MedIconBlock";
import MedPackageImage from "./MedPackageImage.vue";

// import Name from "../dir/file";

export default {
  name: "SimilarMedsDialog",
  components: {
    MedIconBlock,
    MedPackageImage,
  },
  props: {
    similarMeds: null,
    currentCompany: null,
    currentMed: null,
  },
  data: function () {
    return {
      dialog: false,
      hover: false,
      //    headers: [

      //       { text: 'Brand Name', value: 'brand_name' },
      //       { text: 'Manufacturer/Distributor', value: 'labeler_name' }

      //     ],
    };
  },
  methods: {
    slugText(name) {
      return Slugify(name.toLowerCase());
    },
    detailsRouter(id, name) {
      let url = `/meds/details/${id}/`;
      url += this.slugText(name);
      this.$router.push({ path: url });
    },
  },
  computed: {},
};
</script>

<style scoped>
.triggerText {
  cursor: pointer;
  font-size: smaller;
  /* margin: 0 0 20px; */
}
.bHoverin {
  background-color: #f7fcff;
}
.imageDivWidth {
  width: 120px;
  text-align: center;
}
</style>
